import { DotCmsPageRequestParameters } from '../../services/dot-cms-resource/dot-cms-resource.service';

import { CustomDotCmsQueryParams } from './custom-dot-cms-query-params.model';

export class CustomDotCmsQueryParamsMapper {
  static queryParamsMapper(queryparams: CustomDotCmsQueryParams): DotCmsPageRequestParameters {
    return {
      depth: queryparams.depth,
      personaId: queryparams['com.dotmarketing.persona.id'],
      language: queryparams.language_id,
      variantName: queryparams.variantName,
      // mode: queryparams.mode,
    };
  }
}
